<template>
  <section class="flex flex-col gap-5"> 
    <span class="text-2xl font-bold text-white">Wallet Balance Tracker</span>
    <Card class="flex flex-col gap-4 p-5">
      <WalletBalanceTrackerChart
        v-if="walletBalanceTracker && !isMobile"
        :data-list="walletBalanceTracker.walletList"
      />
      <WalletBalanceTrackerMobileChart
        v-if="walletBalanceTracker && isMobile"
        :data-list="walletBalanceTracker.walletList"
      /> 
      <LivewatchPoweredBy class="mobile:mt-4" />
    </Card>
  </section>
</template>

<script setup lang="ts">
import { useBrowserResize } from 'xangle-ui/src/composables/useBrowserResize'

import type { LivewatchWalletBalanceTracker } from '~/api/service/livewatch/wallet-balance-tracker.service'

import WalletBalanceTrackerChart from './charts/WalletBalanceTrackerChart.vue'
import WalletBalanceTrackerMobileChart from './charts/WalletBalanceTrackerMobileChart.vue'
import LivewatchPoweredBy from './labels/LivewatchPoweredBy.vue'
const { isMobile } = useBrowserResize()
type Props = {
  walletBalanceTracker: LivewatchWalletBalanceTracker
}

defineProps<Props>()


</script>